// extracted by mini-css-extract-plugin
export var button = "_d2-0";
export var donut = "_d2-1";
export var donutFill = "_d2-3";
export var donutTrack = "_d2-2";